export const DISPLAY = Object.freeze({
  grid: 'grid',
  table: 'table',
})
